import { Link } from "react-router-dom";
import { Crown, ArrowRight, Check } from "lucide-react";
import Card from "./atoms/Card";
import Chip from "./atoms/Chip";
import Button from "./atoms/Button";

export function isPremium() {
  const plan = localStorage.getItem("userPlan");
  return plan && plan !== "free";
}

export function isIELTS() {
  const plan = localStorage.getItem("userPlan");
  return plan === "app_ielts" || plan === "app_family";
}

export function getUserPlan() {
  return localStorage.getItem("userPlan") || "free";
}

// Days 1-12 free.
export function isLessonFree(day) {
  return day <= 12;
}

export default function PremiumGate({ feature, children }) {
  if (isPremium()) return children;

  return (
    <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "32px 24px" }}>
      <div style={{ maxWidth: 480, width: "100%" }}>
        <Card paperDeep spineColor="var(--gold-500)" style={{ paddingTop: 32, textAlign: "center" }}>
          <div style={{ width: 56, height: 56, borderRadius: 999, background: "var(--paper)", border: "1px solid var(--gold-500)", color: "var(--gold-700)", display: "inline-flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
            <Crown size={26} strokeWidth={1.5} />
          </div>
          <Chip tone="gold">Premium</Chip>
          <h2 className="font-display" style={{ fontSize: 36, fontWeight: 400, lineHeight: 1.05, margin: "12px 0 8px", letterSpacing: "-0.025em" }}>
            <em style={{ color: "var(--gold-500)" }}>{feature || "This feature"}</em> opens with Premium.
          </h2>
          <p style={{ color: "var(--fg-2)", fontSize: 15, lineHeight: 1.6, margin: "0 0 24px" }}>
            ₹249/mo. Cancel any time. The next thirty-eight lessons, twenty conversation scenarios, and a completion certificate.
          </p>

          <ul style={{ listStyle: "none", padding: 0, margin: "0 0 24px", textAlign: "left" }}>
            {[
              "All 50 lessons unlocked",
              "20 AI conversation scenarios",
              "Unlimited speak practice",
              "Stories, idioms, and listening library",
              "Completion certificate",
            ].map((line) => (
              <li key={line} style={{ display: "flex", gap: 10, padding: "6px 0", fontSize: 14, color: "var(--fg-2)" }}>
                <Check size={16} strokeWidth={1.8} color="var(--sage-dark)" style={{ flexShrink: 0, marginTop: 3 }} />
                <span>{line}</span>
              </li>
            ))}
          </ul>

          <Link to="/pricing" style={{ textDecoration: "none", display: "block" }}>
            <Button variant="primary" size="lg" style={{ width: "100%", justifyContent: "center" }} iconRight={<ArrowRight size={16} strokeWidth={1.8} />}>
              See plans
            </Button>
          </Link>
          <p style={{ fontSize: 12, color: "var(--fg-3)", margin: "12px 0 0" }}>
            7-day refund on the first month.
          </p>
        </Card>
      </div>
    </div>
  );
}

// Inline upgrade banner for partially-locked pages.
export function UpgradeBanner({ message }) {
  return (
    <div style={{ background: "var(--ink-900)", color: "var(--paper)", borderRadius: "var(--radius-md)", padding: "14px 18px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, flexWrap: "wrap" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
        <Crown size={20} strokeWidth={1.5} color="var(--gold-300)" style={{ flexShrink: 0 }} />
        <p style={{ fontSize: 14, fontWeight: 500, margin: 0 }}>
          {message || "Premium opens the rest of the curriculum."}
          <span style={{ color: "rgba(251,246,232,0.65)" }}> ₹249/mo · cancel any time.</span>
        </p>
      </div>
      <Link to="/pricing" style={{ textDecoration: "none", flexShrink: 0 }}>
        <Button variant="primary" size="sm" iconRight={<ArrowRight size={14} strokeWidth={1.8} />}>See plans</Button>
      </Link>
    </div>
  );
}
